/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VoceForm } from './voce-form';


export interface ErroreClientSegnalazioneForm { 
    app?: string;
    versione_app?: string;
    piattaforma?: string;
    device_id?: string;
    errori?: Array<VoceForm>;
}

